import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// https://stackoverflow.com/questions/53733807/disabling-console-log-in-production
if (environment.production) {
  //window.console.log = () => { }  //uncomment this line to disable console.log

  // console.log = function (): void { };
  // console.debug = function (): void { };
  // console.warn = function (): void { };
  // console.info = function (): void { };
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));



